export default __webpack_public_path__ + "static/media/99F6BCCB-B0C9-4629-91F2-CA6D8400A28A_1_105_c.ea26b743.jpeg";